import { useState } from 'react';
import type { FaqItem } from '@/mocks/faq';

interface FaqAccordionProps {
  items: FaqItem[];
}

export default function FaqAccordion({ items }: FaqAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <div className="divide-y divide-background-200 overflow-hidden rounded-xl border border-background-200 bg-background-50">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div key={item.q}>
            <h3>
              <button
                type="button"
                onClick={() => setOpenIndex(isOpen ? -1 : index)}
                aria-expanded={isOpen}
                className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100"
              >
                <span className="font-heading text-sm font-semibold text-foreground-950 md:text-base">{item.q}</span>
                <span
                  className={`flex h-7 w-7 flex-none items-center justify-center rounded-full transition-colors ${
                    isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-700'
                  }`}
                >
                  <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'}></i>
                </span>
              </button>
            </h3>
            {isOpen ? (
              <div className="animate-fade-in px-5 pb-5 pr-12">
                <p className="text-sm leading-relaxed text-foreground-700">{item.a}</p>
              </div>
            ) : null}
          </div>
        );
      })}
    </div>
  );
}